import {mapContactMessageDbToType, type ContactMessage, type ContactMessageDb} from '@cp/model';
import {useLayoutEffect} from 'react';
import {
  CONTACT_MESSAGE_PAGE_SIZE,
  ListContactMessageOptions,
  listContactMessageQuery,
} from '../../api/contactMessage/listContactMessage';
import {FirestoreCursor} from '../../types/FirestoreCursor';
import useFunctionPagination from '../helper/function/useFunctionPagination';

export function useListContactMessage(uid?: string, options: ListContactMessageOptions = {}) {
  const pagination = useFunctionPagination<ContactMessage, ContactMessageDb>(
    (cursor: FirestoreCursor) =>
      listContactMessageQuery(options, CONTACT_MESSAGE_PAGE_SIZE, cursor).then((snapshot) => snapshot.docs),
    mapContactMessageDbToType,
    {
      skip: uid === undefined,
      countFn: () => listContactMessageQuery(options).then((snapshot) => snapshot.size),
    },
  );

  useLayoutEffect(() => {
    pagination.clearData();
  }, [uid]);

  return pagination;
}
